import React from "react";
import styled from "styled-components";
import circleImg1 from "../../../assets/images/product-detail/circle2.png";
import circleImg2 from "../../../assets/images/product-detail/circle1.png";

export const DetailWithImage = ({ title, content, image }) => (
	<Wrapper>
		<img src={circleImg1} alt='circle1' className='circle-img1' />
		<h1 className='text-center mb-5'>{title}</h1>
		<div className='row'>
			<div className='col-sm-12 col-md-5 col-lg-4'>
				<p>{content}</p>
			</div>
			<div className='col-sm-12 col-md-6 col-lg-7'>
				<img className='img-with-shadow' src={image} alt='img' />
			</div>
		</div>
		<img src={circleImg2} alt='circle2' className='circle-img2' />
	</Wrapper>
);

const Wrapper = styled.div`
	overflow: hidden;
	width: 90%;
	margin: 0 auto;
	padding: 100px 0;
	position: relative;

	.circle-img1 {
		position: absolute;
		width: 300px;
		top: 10px;
		left: 30%;
		z-index: -1;
	}

	.circle-img2 {
		position: absolute;
		width: 300px;
		bottom: 20px;
		right: 30%;
		z-index: -1;
	}

	h1 {
		color: #5268c2;
		font-weight: 700;
		margin-bottom: 50px;
	}
	h1 {
		font-size: 48px;
	}
	p {
		padding: 5em 14px;
		font-size: 20px;
		color: #5268c2;
	}

	@media screen (max-width: 600px) {
		div {
			width: 100%;
		}
		p {
			padding: 5em 10px;
			font-size: 18px;
		}
	}
`;
